// extracted by mini-css-extract-plugin
module.exports = {"root":"Error_root__jhKeT","title":"Error_title__hM_Fl","subtitle":"Error_subtitle__Lc5g7","doneButton":"Error_doneButton__qAjWv"};